import useDefinedContext from "hooks/useDefinedContext";
import { AddOneRepMaxDialogContext } from "../AddOneRepMaxDialogProvider";

function useAddOneRepMaxDialog() {
  return useDefinedContext(AddOneRepMaxDialogContext);
}

export default useAddOneRepMaxDialog;
